export default __webpack_public_path__ + "images/260153af175cddc599cec7633a03bab9.svg";